/* Cooked motion layer v2 (2026-09-10): inertia scroll, custom cursor, magnetic CTAs,
   word-mask headline reveals, lookbook parallax, scroll-velocity marquee, image fade-in.
   Everything respects prefers-reduced-motion and only runs where it makes sense. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;

  /* ---------- 1. Inertia scroll (desktop, mouse/trackpad only) ---------- */
  function setupInertia() {
    if (reduced || !fine) return;
    var target = window.scrollY, current = target, raf = null, active = false, lastSet = -1;
    function maxY() { return Math.max(0, html.scrollHeight - window.innerHeight); }
    function loop() {
      var diff = target - current;
      if (Math.abs(diff) < 0.4) {
        current = target; lastSet = current; window.scrollTo(0, current);
        raf = null; active = false; html.classList.remove('is-inertia'); return;
      }
      current += diff * 0.11; lastSet = current; window.scrollTo(0, current);
      raf = requestAnimationFrame(loop);
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.metaKey) return;
      if (document.body.style.overflow === 'hidden' || document.body.classList.contains('lb-open')) return;
      var t = e.target;
      if (t && t.closest && t.closest('cart-drawer, dialog, .cooked-sg-modal, .cooked-welcome, [data-native-scroll], .menu-drawer, details-modal, .predictive-search, .drawer')) return;
      var d = e.deltaY;
      if (e.deltaMode === 1) d *= 16; else if (e.deltaMode === 2) d *= window.innerHeight;
      if (Math.abs(e.deltaX) > Math.abs(d)) return;
      e.preventDefault();
      if (!active) { target = window.scrollY; current = target; active = true; html.classList.add('is-inertia'); }
      target = Math.min(maxY(), Math.max(0, target + d));
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: false });
    window.addEventListener('scroll', function () {
      if (!active) return;
      if (Math.abs(window.scrollY - lastSet) > 2) { target = current = window.scrollY; }
    }, { passive: true });
  }

  /* ---------- 2. Custom cursor ---------- */
  function setupCursor() {
    if (reduced || !fine) return;
    var c = document.createElement('div');
    c.className = 'cooked-cur'; c.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span'); label.className = 'cooked-cur__label'; c.appendChild(label);
    document.body.appendChild(c);
    var x = window.innerWidth / 2, y = window.innerHeight / 2, cx = x, cy = y, raf = null, visible = false;
    function loop() {
      cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      raf = (Math.abs(x - cx) > 0.2 || Math.abs(y - cy) > 0.2) ? requestAnimationFrame(loop) : null;
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if (!visible) { visible = true; c.classList.add('is-visible'); html.classList.add('has-cursor'); }
      if (!raf) raf = requestAnimationFrame(loop);
      var t = e.target;
      var el = t && t.closest ? t.closest('[data-cursor]') : null;
      if (el) { c.classList.add('is-active'); c.classList.remove('is-link'); label.textContent = el.getAttribute('data-cursor'); return; }
      var link = t && t.closest ? t.closest('a, button, [role="button"], input, select, textarea, label, summary, .cooked-qa__size') : null;
      c.classList.toggle('is-link', !!link); c.classList.remove('is-active'); label.textContent = '';
    }, { passive: true });
    document.addEventListener('pointerdown', function () { c.classList.add('is-down'); }, { passive: true });
    document.addEventListener('pointerup', function () { c.classList.remove('is-down'); }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () { c.classList.remove('is-visible'); visible = false; });
    document.documentElement.addEventListener('mouseenter', function () { c.classList.add('is-visible'); visible = true; });
  }

  /* ---------- 3. Magnetic CTAs ---------- */
  function setupMagnetic() {
    if (reduced || !fine) return;
    var els = document.querySelectorAll('[data-magnetic], .cooked-hero__cta, .cooked-lookbook__cta, .cooked-newsletter__btn, .cooked-404__cta, .cooked-pdp__cta, .cooked-cart__checkout, .cooked-collection__empty-cta');
    els.forEach(function (el) {
      var r = null;
      el.addEventListener('pointerenter', function () { r = el.getBoundingClientRect(); }, { passive: true });
      el.addEventListener('pointermove', function (e) {
        if (!r) r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        el.style.transition = 'transform .12s ease-out';
        el.style.transform = 'translate(' + (dx * 10).toFixed(1) + 'px,' + (dy * 8).toFixed(1) + 'px)';
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)'; el.style.transform = ''; r = null;
      }, { passive: true });
    });
  }

  /* ---------- 4. Word-mask headline reveals ---------- */
  var SPLIT = '.cooked-current-drop__title, .cooked-statement__title, .cooked-collection__title, .cooked-related__title, .cooked-newsletter__title, .cooked-meanings__title, .cooked-search__title, .cooked-cart__title, .cooked-404__title';
  function setupSplit() {
    var els = document.querySelectorAll(SPLIT);
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';
      var dot = el.querySelector('.cooked-orange-dot');
      var text = '';
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (n === dot) return;
        text += n.textContent;
      });
      var words = text.replace(/\s+/g, ' ').trim().split(' ');
      if (!words.length || !words[0]) return;
      el.textContent = '';
      words.forEach(function (w, i) {
        var o = document.createElement('span'); o.className = 'cooked-split__w';
        var inner = document.createElement('span'); inner.className = 'cooked-split__i';
        inner.style.transitionDelay = (i * 60) + 'ms'; inner.textContent = w;
        o.appendChild(inner); el.appendChild(o);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
      if (dot) el.lastElementChild.firstChild.appendChild(dot);
    });
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  /* ---------- 5. Lookbook scale parallax ---------- */
  function setupLookbook() {
    if (reduced) return;
    var img = document.querySelector('.cooked-lookbook__media img');
    if (!img) return;
    var wrap = img.closest('.cooked-lookbook__media');
    var ticking = false;
    function update() {
      ticking = false;
      var r = wrap.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      var s = 1.10 - 0.10 * p, ty = (p - 0.5) * -5;
      img.style.transform = 'scale(' + s.toFixed(3) + ') translateY(' + ty.toFixed(2) + '%)';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- 6. Marquee speeds up with scroll velocity ---------- */
  function setupMarquee() {
    if (reduced) return;
    var tracks = document.querySelectorAll('.cooked-marquee__track');
    if (!tracks.length || !tracks[0].getAnimations) return;
    var last = window.scrollY, v = 1, raf = null;
    function set(rate) { tracks.forEach(function (t) { var a = t.getAnimations()[0]; if (a) a.playbackRate = rate; }); }
    function decay() {
      raf = null; v += (1 - v) * 0.08;
      if (Math.abs(v - 1) > 0.02) { set(v); raf = requestAnimationFrame(decay); } else { v = 1; set(1); }
    }
    window.addEventListener('scroll', function () {
      var d = Math.abs(window.scrollY - last); last = window.scrollY;
      v = Math.min(6, Math.max(v, 1 + d / 14)); set(v);
      if (!raf) raf = requestAnimationFrame(decay);
    }, { passive: true });
  }

  /* ---------- 7. Image fade-in ---------- */
  function setupImgFade() {
    var imgs = document.querySelectorAll('.cooked-product-card__img:not(.cooked-product-card__img--alt), .cooked-pdp__img, .cooked-statement__image img, .cooked-lookbook__media img, .cooked-meanings__img img');
    imgs.forEach(function (img) {
      img.classList.add('cooked-fade');
      if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    });
    setTimeout(function () { imgs.forEach(function (img) { img.classList.add('is-loaded'); }); }, 3000);
  }

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true }); else fn(); }
  ready(function () {
    setupImgFade();
    setupSplit();
    setupInertia();
    setupCursor();
    var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 150); };
    idle(function () { setupMagnetic(); setupLookbook(); setupMarquee(); });
  });
})();